import { useEffect } from 'react';
import { useAppDispatch } from 'hooks';
import { setSipCallStatesByKey } from 'reducers/workflows';
import type { ZendeskSipCallTriggerStepComponent } from 'api/types';

interface SipCallTriggerStepProps {
  isLastStep: boolean;
  setStepSent: (query?: string) => void;
  stepIndex: number;
  widgetComponent: ZendeskSipCallTriggerStepComponent;
}

export function ZendeskSipCallTriggerStep({
  setStepSent,
  widgetComponent,
}: SipCallTriggerStepProps) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (widgetComponent.isSent) {
      return;
    }

    // Set the SIP call drawer to be visible when this component mounts
    dispatch(setSipCallStatesByKey({ isVisible: true }));
    // Mark the step as sent since we've processed the data
    setStepSent();
  }, [dispatch, widgetComponent, setStepSent]);

  // This component renders nothing - it's just for triggering the global drawer
  return null;
}
